import auth from "../middlewares/auth";
export const gallery = [
    {
        path: '/gallery',
        component: () => import(/* webpackChunkName: "gallery" */ '../views/gallery/Index'),
        name: 'gallery',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/gallery/view/:id',
        component: () => import(/* webpackChunkName: "gallery" */ '../views/gallery/View'),
        name: 'gallery_view',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
